import ValidateAddressRequestModelBase from '../_generated/modelBases/validate-address-request-model-base';

export default class ValidateAddressRequestModel extends ValidateAddressRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
